/**
 * Labstep
 *
 * @module components/Molecule/Precautionarys
 * @desc Showing molecule hazards
 */

import { precautionaryStatements } from 'labstep-web/components/Molecule/Safety/constants';
import type React from 'react';
import { MoleculeSafetyCodeList } from '..';
import type { MoleculeSafetyPrecautionaryProps } from './types';

export const PRECAUTIONARY_CODE_TYPES = [
  'General',
  'Prevention',
  'Response',
  'Storage',
  'Disposal',
];

export const MoleculeSafetyPrecautionary: React.FC<
  MoleculeSafetyPrecautionaryProps
> = ({ parent, pubChemMetadata }) => {
  const { precautionary } = pubChemMetadata.Safety;

  return (
    <>
      {PRECAUTIONARY_CODE_TYPES.map((type) => (
        <MoleculeSafetyCodeList
          key={type}
          pubChemMetadata={pubChemMetadata}
          parent={parent}
          type="precautionary"
          subtype={type as any}
          label={type}
          codes={(precautionary?.[type] || []).map((h) => ({
            code: h,
            info: precautionaryStatements[h],
          }))}
        />
      ))}
    </>
  );
};
